export const canUseDOM = (): boolean =>
  Boolean(
    typeof window !== 'undefined' &&
      window.document &&
      // isServer is defined in V1 (bootstrap.js) and the next line should return true when not on the server
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (typeof (global as any).isServer === 'undefined' || (global as any).isServer !== true),
  );
